module.exports = __webpack_public_path__ + "img/china.141b0c3e.png";